var error = {
  translation: {
    error: {
      coreNotFound: 'Kunne ikke hente kerneindstillinger',
      domainNotAllowed: 'Du kan ikke registrere dig med en e-mail fra dette domæne',
      emailAlreadyInUse: 'E-mail er allerede i brug',
      insufficientPermissions: 'Utilstrækkelige rettigheder',
      invalidCurrentPassword: 'Ugyldig nuværende adgangskode',
      invalidPermissions: 'Vælg mindst én tilladelse',
      invalidUsernameOrPassword: 'Ugyldigt brugernavn eller adgangskode',
      localRegistrationDisabled: 'Lokal brugerregistrering er deaktiveret af administrator',
      noInternetConnection: 'Ingen internetforbindelse',
      noOidcProfileFound: 'Ingen OIDC-profil fundet',
      policyNotAccepted: 'Accepter venligst vilkår og privatlivspolitik',
      registrationDisabled: 'Brugerregistrering er deaktiveret af administrator',
      serverConnectionFailed: 'Forbindelse til server mislykkedes',
      ssoRegistrationDisabled: 'SSO-registrering er deaktiveret af administrator',
      tooManyFailedAttempts: 'For mange mislykkede forsøg - prøv igen senere',
      unknownError: 'Ukendt fejl, prøv igen senere',
      usernameAlreadyInUse: 'Brugernavn er allerede i brug',
      weakPassword: 'Brug venligst en stærkere adgangskode',
    },
  },
};

export { error as default };
